<template>
     <!-- <div class="img_footer">
      <div class="footer_content">
        <div class="footer_content_left">
          <ul>
            <li><a href="/#" >常见问题</a> <span>|</span></li>
            <li><a href="/#" >隐私声明</a> <span>|</span></li>
            <li><a href="/#" >智能问答</a> <span>|</span></li>
            <li><a href="/#" >网站地图</a></li>
          </ul>
          <p>主办:宁波市鄞州区政务服务中心</p>
          <p>Copyright @ 2023-2025</p>
          <p>最佳使用效果1920*1080分辨率/建议使用Chrome或者IE edge浏览器</p>
        </div>
        <div class="footer_content_right">
          <ul>
            <li>
              <img src="@/assets/home/footer1.png" alt="" />
              <p>鄞州政务</p>
            </li>
            <li>
              <img src="@/assets/home/footer2.png" alt="" />
              <p>鄞州发布</p>
            </li>
            <li>
              <img src="@/assets/home/footer3.png" alt="" />
              <p>浙里办</p>
            </li>
          </ul>
        </div>
      </div>
    </div> -->
    <div class="img_footer"></div>
</template>

<script>
export default {
  name: 'FooterTotal',
  props: {}
}
</script>

<style scoped>
.img_footer {
  width: 100%;
  height: auto;
  background-color: #000;
}
.img_footer .footer_content {
  display: flex;
  justify-content: space-between;
  width: 1200px;
  height: auto;
  margin: 0 auto;
  padding: 40px 0;
}
.img_footer .footer_content .footer_content_left ul {
  display: flex;
  margin-bottom: 15px;
  padding: 0;
}
.img_footer .footer_content .footer_content_left ul li {
  display: flex;
  color: #fff;
}
.img_footer .footer_content .footer_content_left ul li a {
  font-size: 22px;
  color: #fff;
}
.img_footer .footer_content .footer_content_left ul li span {
  width: 30px;
  line-height: 2;
  text-align: center;
  font-weight: 700;
}
.img_footer .footer_content .footer_content_left p {
  font-size: 18px;
  color: #999;
  margin: 10px 0;
}
.img_footer .footer_content .footer_content_right ul {
  display: flex;
  justify-content: space-between;
}
.img_footer .footer_content .footer_content_right ul li img {
  width: 100px;
  margin-bottom: 15px;
}
.img_footer .footer_content .footer_content_right ul li p {
  font-size: 18px;
  text-align: center;
  color: #999;
}
.img_footer .footer_content .footer_content_right ul li:nth-child(2) {
  margin: 0 20px;
}
</style>
